window.modals = () => {
    return {
        currentlyShowing: [],
        shouldShow(id) {
            return this.currentlyShowing.includes(id);
        },
        show(e) {
            document.querySelector(`#modal-${this.getId(e)}`).style.zIndex =
                100 + document.querySelectorAll('.modal.modal-visible').length;

            this.currentlyShowing.push(this.getId(e));
            document.body.classList.add('overflow-hidden');
        },
        close(e) {
            if (
                document.querySelectorAll('.modal.modal-visible').length === 1
            ) {
                document.body.classList.remove('overflow-hidden');
            }

            this.currentlyShowing = this.currentlyShowing.filter(
                id => id !== this.getId(e),
            );
        },
        getId(e) {
            return typeof e.detail === 'string' ? e.detail : e.detail.id;
        },
    };
};
